import { ConfirmationModal } from './confirmation-modal';
import { I18nTranslator } from '@strength/i18n';

interface DeleteConfirmationModalProps {
  id: string;
  open: boolean;
  title: string;
  message: string;
  cancelText?: string;
  confirmText?: string;
  onDelete: () => void;
  onClose: () => void;
}

/**
 * Modal to confirm the deletion of a an item from the annual planner
 */
export function DeleteConfirmationModal({
  id,
  open,
  title,
  message,
  cancelText,
  confirmText,
  onDelete,
  onClose,
}: DeleteConfirmationModalProps) {
  return (
    <ConfirmationModal
      id={id}
      open={open}
      onConfirm={onDelete}
      onCancel={onClose}
      title={title}
      message={message}
      confirmButtonVariant="containedDestructive"
      cancelText={cancelText}
      confirmText={confirmText}
    />
  );
}

export const deleteBlockText = (t: I18nTranslator) => ({
  title: t('deleteBlock'),
  message: t('deleteBlockMessage'),
});

export const deletePhaseText = (t: I18nTranslator) => ({
  title: t('deletePhase'),
  message: t('deletePhaseMessage'),
});

export const deleteTrackText = (t: I18nTranslator, isSubtrack: boolean) => ({
  title: t('deleteTrack'),
  message: t(isSubtrack ? 'deleteSubtrackMessage' : 'deleteTrackMessage'),
});

export const deleteExerciseText = (t: I18nTranslator) => ({
  title: t('deleteExercise'),
  message: t('deleteExerciseMessage'),
});

export const deleteSchemeText = (t: I18nTranslator) => ({
  title: t('deleteScheme'),
  message: t('deleteSchemeMessage'),
});

export const deleteBlockWorkoutText = (t: I18nTranslator) => ({
  title: t('deleteWorkout'),
  message: t('deleteWorkoutMessage'),
});

export const deleteAthleteWorkoutText = (t: I18nTranslator) => ({
  title: t('deleteAthleteWorkout'),
  message: t('deleteAthleteWorkoutMessage'),
});

export const deleteBlockWorkoutsText = (t: I18nTranslator) => ({
  title: t('deleteBlockWorkouts'),
  message: t('deleteBlockWorkoutsMessage'),
});

